import { observable, action, computed, makeObservable } from 'mobx';

import { logger, LogEvents } from 'helpers';
import { StoreModel } from '../Index';
import { goHome } from 'sdk/InternalSdk';

export enum WizardStep {
    CashAccepter = 'CashAccepter',
    PrintReceipt = 'PrintReceipt',
    EmailAddress = 'EmailAddress',
    Farewell = 'Farewell',
    ApplicationSelect = 'ApplicationSelect',
}

export class WizardModel {
    @observable
    public currentStep: WizardStep;

    @observable
    public steps: WizardStep[] = [
        WizardStep.CashAccepter,
        WizardStep.PrintReceipt,
        WizardStep.EmailAddress,
        WizardStep.Farewell,
    ];

    constructor(private root: StoreModel) {
        this.setFirstStep();
        makeObservable(this);
    }

    @action
    setFirstStep = () => {
        this.currentStep = this.steps[0];
    }
    @action
    setCurrentStep = (step: WizardStep) => {
        this.currentStep = step;
    }

    @action
    goToStep(step: WizardStep) {
        if (
            !this.root.peripheryStatus.isKioskOnline &&
            step === WizardStep.Farewell
        ) {
            this.root.billpay.reset();

            return goHome();
        }

        logger.logInformation(
            'Wizard Step changed.',
            LogEvents.WizardStepChanged,
            {
                previousStep: this.currentStep && this.currentStep.toString(),
                currentStep: step.toString(),
            }
        );

        this.setCurrentStep(step);
    }

    @computed
    get totalSteps(): number {
        return this.steps.length;
    }

    reset() {
        this.currentStep = this.steps[0];
    }
}
